module.exports = __webpack_public_path__ + "img/awards6.afc761cb.svg";